import $ from 'jquery';

const $page = $('.page');
const $header = $('.header');
const $toggler = $('.js-header-menu-toggler');

export default class Header {
	handleMenuToggle() {
		$header.toggleClass('header_menu-open');
		$page.toggleClass('page_mobile-menu');
	}

	onScroll() {
		const {scrollY} = window;
		const shadowClass = 'header_with-shadow';

		if (scrollY === 0) {
			$header.removeClass(shadowClass);
		}
		else if (!$header.hasClass(shadowClass)) {
			$header.addClass(shadowClass);
		}
	}

	handleKeyboardFocus() {
		const navLink = '.header__nav-link';
		const navSublist = '.header__nav-sublist';
		const focusedClass = 'focused';

		$('.header__nav')
			.on('focus', navLink, function () {
				const el = $(this);

				el.parent().toggleClass(focusedClass);
				el.parent().attr('aria-expanded', 'true');
			})
			.on('blur', navLink, function () {
				const el = $(this);

				el.parent().toggleClass(focusedClass);
				setTimeout(function () {
					if (el.siblings(navSublist).attr('data-has-focus') !== 'true' ) {
						el.parent().attr('aria-expanded', 'false');
					}
				}, 100);
			})
			.on('focusin', navSublist, function () {
				$(this).attr('data-has-focus', 'true' );
			})
			.on('focusout', navSublist, function () {
				const el = $(this);

				setTimeout(function () {
					if (el.find(':focus').length === 0) {
						el.attr('data-has-focus', 'false');

						if (!el.parent().hasClass(focusedClass)) {
							el.parent().attr('aria-expanded', 'false');
						}
					}
				}, 100 );
			});
	}

	init() {
		$toggler.on('click', this.handleMenuToggle);
		this.onScroll();
		window.addEventListener('scroll', this.onScroll);
		this.handleKeyboardFocus();
	}
}



// WEBPACK FOOTER //
// ./app/blocks/header/index.js